export default __webpack_public_path__ + "static/media/latest-news-img3.17216db8.jpg";